import React from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonLoading = ({
  loading = false,
  style = { circle: false, width: "100%", height: 15, className: "" },
  children = <></>,
}) => {
  return loading ? (
    <Skeleton
      circle={style?.circle}
      width={style?.width}
      height={style?.height}
      containerClassName={style?.className}
    />
  ) : (
    children
  );
};

export default SkeletonLoading;
